module.exports = "<h2 class=\"dash-header\" hide-xs>\n  <span>View Companies</span>\n</h2>\n<span flex>\n"